import React, { useState, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";

const Sidebar = () => {
  const location = useLocation();
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  const [filteredSidebarData, setFilteredSidebarData] = useState([]);

  useEffect(() => {
  let userPermissions = [];
  
  try {
    const rolesPermissions = localStorage.getItem("rolespermissions");
    // console.log("Raw rolesPermissions:", rolesPermissions);
    if (rolesPermissions) {
      const parsedRoles = JSON.parse(rolesPermissions);
      const permissions = parsedRoles.permissions;
      if (typeof permissions === "string") {
        const parsedPermissions = JSON.parse(permissions);
        userPermissions = Array.isArray(parsedPermissions)
          ? parsedPermissions
          : parsedPermissions.permissions || [];
      } else if (Array.isArray(permissions)) {
        userPermissions = permissions;
      } else {
        console.error("Permissions format is invalid:", permissions);
        userPermissions = [];
      }
    } else {
      console.log("No rolesPermissions found in localStorage");
    }
  } catch (error) {
    console.error("Error parsing permissions:", error);
    userPermissions = [];
  }

  if (userPermissions.length === 0) {
    console.log("Using hardcoded permissions for testing");
    userPermissions = [
      {
        title: "Main",
        enabled: true,
        url: "",
        childPage: [
          {
            title: "Dashboard",
            enabled: true,
            submenu: true,
            childPage: [{ title: "Admin Dashboard", enabled: true }],
          },
        ],
      },
    ];
  }

  // console.log("Parsed Permissions:", userPermissions);
  const flattenChildPages = (childPages) => {
    let flattened = [];
    childPages.forEach((item) => {
      if (item.enabled) {
        flattened.push({ title: item.title, enabled: item.enabled, link: item.url || "" });
        if (item.childPage && item.childPage.length > 0) {
          flattened = flattened.concat(flattenChildPages(item.childPage));
        }
      }
    });
    return flattened;
  };

  const filtered = SidebarData.map((mainSection) => {
    const permissionSection = userPermissions.find(
      (p) => p.title === mainSection.label
    );

    if (!permissionSection || !permissionSection.enabled) {
      return null;
    }

    const filteredSubmenuItems = mainSection.submenuItems?.map((submenuItem) => {
      const matchingPermission = permissionSection.childPage?.find(
        (child) => child.title === submenuItem.label
      );

      if (!matchingPermission || !matchingPermission.enabled) {
        return null;
      }

      const filteredSubSubItems = matchingPermission.childPage
        ? flattenChildPages(matchingPermission.childPage)
        : [];

      if (submenuItem.submenu && submenuItem.submenuItems) {
        const filteredNestedItems = submenuItem.submenuItems.map((subSubItem) => {
          const subSubPermission = filteredSubSubItems.find(
            (child) => child.title === subSubItem.label
          );
          return subSubPermission ? { ...subSubItem, enabled: subSubPermission.enabled } : null;
        }).filter((item) => item && item.enabled);

        if (filteredNestedItems.length === 0) {
          return null;
        }

        return {
          ...submenuItem,
          submenuItems: filteredNestedItems,
        };
      }

      return submenuItem;
    }).filter(Boolean);

    if (filteredSubmenuItems.length === 0) {
      return null;
    }

    return {
      ...mainSection,
      submenuItems: filteredSubmenuItems,
    };
  }).filter(Boolean);

  // console.log("Filtered Sidebar Data:", filtered);
  setFilteredSidebarData(filtered);
}, []);

  const toggleSidebar = (title) => {
    setSubopen(subOpen === title ? "" : title);
  };

  const toggleSubsidebar = (subitem) => {
    setSubsidebar(subsidebar === subitem ? "" : subitem);
  };

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredSidebarData.length === 0 ? (
                  <li>No available menu items</li>
                ) : (
                  filteredSidebarData.map((mainLabel) => (
                    <li className="submenu-open" key={mainLabel.label}>
                      <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                      <ul>
                        {mainLabel?.submenuItems?.map((title) => {
                          const isActive = title?.submenu
                            ? title?.submenuItems?.some(
                                (link) =>
                                  link?.link === location.pathname ||
                                  (link?.submenu &&
                                    link?.submenuItems?.some(
                                      (item) => item?.link === location.pathname
                                    ))
                              )
                            : title?.link === location.pathname;

                          return (
                            <li className="submenu" key={title.label}>
                              <Link
                                to={title?.link || "#"}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${subOpen === title?.label ? "subdrop" : ""} ${
                                  isActive ? "active" : ""
                                }`}
                              >
                                {title?.icon}
                                <span>{title?.label}</span>
                                {title?.submenu && <span className="menu-arrow" />}
                              </Link>
                              {title?.submenu && (
                                <ul
                                  style={{
                                    display: subOpen === title?.label ? "block" : "none",
                                  }}
                                >
                                  {title?.submenuItems?.map((item) => (
                                    <li className="submenu submenu-two" key={item.label}>
                                      <Link
                                        to={item?.link || "#"}
                                        className={
                                          item?.submenuItems?.some(
                                            (link) => link?.link === location.pathname
                                          ) || item?.link === location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => toggleSubsidebar(item?.label)}
                                      >
                                        {item?.label}
                                        {item?.submenu && <span className="menu-arrow" />}
                                      </Link>
                                      {item?.submenu && (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === item?.label ? "block" : "none",
                                          }}
                                        >
                                          {item?.submenuItems?.map((subItem) => (
                                            <li key={subItem.label}>
                                              <Link
                                                to={subItem?.link}
                                                className={`submenu-two ${
                                                  subItem?.link === location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {subItem?.label}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;